export default __webpack_public_path__ + "static/media/checked.3e2b87e6.svg";